import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  updateMediaGallery = (event) => {
    const fetchedHtml = event.detail.data.html;
    const newMediaGallery = fetchedHtml.querySelector('product-media-gallery slider-component');
    const currentMediaGallery = this.querySelector('slider-component');

    if (!newMediaGallery || !currentMediaGallery) return;

    // Prevent out-of-order variant response race conditions
    const fetchedPicker = fetchedHtml.querySelector('variant-picker');
    const fetchedVariantId = fetchedPicker ? fetchedPicker.querySelector('input[name="id"]')?.value : null;

    // Get the current variant ID from either URL or active picker state
    const currentVariantId = new URLSearchParams(window.location.search).get('variant') || 
                             document.querySelector('variant-picker input[name="id"]')?.value;

    if (fetchedVariantId && currentVariantId && fetchedVariantId !== currentVariantId) {
      console.log('Discarding out-of-order variant gallery update:', fetchedVariantId, 'vs', currentVariantId);
      return;
    }

    if (currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.replaceWith(newMediaGallery);
    }

    // Also replace mobile swiper gallery so both desktop and mobile galleries sync
    const newMobileGallery = fetchedHtml.querySelector('product-media-gallery .mobile-swiper-gallery');
    const currentMobileGallery = this.querySelector('.mobile-swiper-gallery');
    if (newMobileGallery && currentMobileGallery) {
      if (currentMobileGallery.innerHTML !== newMobileGallery.innerHTML) {
        currentMobileGallery.replaceWith(newMobileGallery);

        window.initMobileGallery();
      }
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}


document.addEventListener("DOMContentLoaded", function(){

  // const loadMoreBtn = document.querySelector('[data-ref="load-more"]');
  // const gallery = document.querySelector('.product-media-gallery-main-slider');

  // if(loadMoreBtn && gallery){
  //   loadMoreBtn.addEventListener("click", function(){
  //     gallery.setAttribute("aria-expanded","true");
  //   });
  // }
  document.addEventListener("click", function(e){

  const loadMoreBtn = e.target.closest('[data-ref="load-more"]');
  const gallery = document.querySelector('.product-media-gallery-main-slider');

  if(loadMoreBtn && gallery){
    gallery.setAttribute("aria-expanded","true");
  }

});

});

